'use strict';

const google = require('../../modules/google');
const isSmallView = require('../../modules/helpers/isSmallView');

const inStoreData = {
    variationProductID: null,
    latitude: null,
    longitude: null
};


// Initializers
function initializeEvents() {

    // Current location
    $('body').on('click', '.js-check-instore-availabilty-current-location', checkCurrentLocation);

    $('body').on('keyup', '.js-check-instore-availabilty-wrapper', function(e){
        if (e.which == 13) {
           checkCurrentLocation();
        }
    });

    //Show more button
    $('.js-show-more-btn').on('click', function() {
        $('.js-spinner').addClass('spinner-visible');
        const nextPageToken = $('[name=NextPageToken]').last().val() || 0;
        getStoreStock(nextPageToken);
    });

    //Variant selection
    $('.js-swatch-anchor-flyout').on('click', function(e) {
        $('.js-spinner').addClass('spinner-visible');

        updatePDPSizeSelection(this.innerText);
        e.preventDefault();
        e.stopPropagation();
        updateSizeSelectionBar($(this));
        if (!inStoreData.longitude || !inStoreData.latitude) {

            // address field is empty, fill with current location
            cleanFlyoutStores(); //Clean the flyout
            google.places.getCurrentLocation(triggerCurrentLocation);
            return;
        }

        inStoreData.variationProductID = $(this).data('productid');
        cleanFlyoutStores(); //Clean the flyout
        getStoreStock(0);

    });
}

function checkCurrentLocation() {
    $('.js-spinner').addClass('spinner-visible');
    cleanFlyoutStores(); //Clean the flyout
    google.places.getCurrentLocation(triggerCurrentLocation);
}


// Triggers

/*
    Trigger for autocomplete functionality. Once address is selected, we get notified in here
*/
function triggerReceiveAddressAutoComplete() {
    google.tagManager.pushInStoreAvailabilityAddressFill();
    const place = this.getPlace();
    if (place && place.geometry && place.geometry.location) {
        $('.js-spinner').addClass('spinner-visible');

        //Set the location
        inStoreData.latitude = place.geometry.location.lat();
        inStoreData.longitude = place.geometry.location.lng();
        cleanFlyoutStores(); //Clean the flyout
        getStoreStock(0);
    }
}

/*
    Notifier when search for user's address in addressbook
*/
function triggerUserAddressSearched(results, status) {
    $('.js-spinner').addClass('spinner-visible');
    if (status == 'OK') {
        //Set the location
        const result = results[0];
        inStoreData.latitude = result.geometry.location.lat();
        inStoreData.longitude = result.geometry.location.lng();
        setSearchTextfieldText(result.formatted_address);
        cleanFlyoutStores(); //Clean the flyout
        getStoreStock(0);
    }
}

/*
    Notifier when user tap on Current location
*/
function triggerCurrentLocation(result, latitude, longitude) {
    //Check if location is OK
    if (result && latitude && longitude) {
        const cityName = google.places.getReadableAddress(result);
        setSearchTextfieldText(cityName);
        inStoreData.latitude = latitude;
        inStoreData.longitude = longitude;
        cleanFlyoutStores();
        getStoreStock(0);
    } else {
        //Something wrong with current location, just fallback to Request's geolocation
        const RequestLatitude = $('[name=RequestLatitude]')[0].value;
        const RequestLongitude = $('[name=RequestLongitude]')[0].value;
        if (RequestLatitude && RequestLongitude) {
            google.places.getLocationFromLatLong(RequestLatitude, RequestLongitude, triggerCurrentLocationDW);
        } else {
            //Something wrong with DW geolocation, Show error message
            $('.js-location-not-found').show();
        }
    }

}

/*
    Notifier when Google API is finished for location which is from DW's geolocation
*/
function triggerCurrentLocationDW(result, latitude, longitude) {
    //Check if result is OK
    if (result && latitude && longitude) {
        const cityName = google.places.getReadableAddress(result);
        setSearchTextfieldText(cityName);
        inStoreData.latitude = latitude;
        inStoreData.longitude = longitude;

        cleanFlyoutStores();
        getStoreStock(0);
    } else {
        //If something's wrong with DW geolocation, show the error message
        $('.js-location-not-found').show();
    }
}

/*
    Getter ProductID
*/
function getFlyoutProductId() {
    if (inStoreData.variationProductID) {
        return inStoreData.variationProductID;
    }

    const el = $('[name=pid]')[0];
    return el.dataset.retailtu ? el.dataset.retailtu : el.value;
}

/*
    Update variant selector on PDP
*/
function updatePDPSizeSelection(selectedSize) {
    $('.js-swatch-anchor').each(function() {
        if (this.innerText == selectedSize) {
            if ($(this).hasClass('js-swatch-unselectable')) { return; }
            if ($(this).parent('li').hasClass('selected')) { return; }
            $(this).click();
        }
    });
}

/*
   Update the variant selection
*/
function updateSizeSelectionBar($clickedSize) {
    $('.js-swatch-anchor-flyout').each(function() {
        $(this).parent('li').removeClass('selected');
    });
    $clickedSize.parent('li').addClass('selected');
}

/*
    Set text to searchfield
*/
function setSearchTextfieldText(text) {
    $('.js-check-instore-availabilty-zipcode-textfield').val(text);
    // trigger change in input field to activate floating labels
    $('.js-check-instore-availabilty-zipcode-textfield').trigger('change');
}

/*
    Clean stores
*/
function cleanFlyoutStores() {
    $('.js-location-not-found').hide(); //Hide custom error message
    $('.js-size-not-selected').hide(); //Hide size selection error message
    $('.show-more-btn').hide(); //Hide show more button

    //clean previous store list and messages
    $('.stores-list-wrapper .js-list-row').remove();
    $('.stores-list-wrapper .error').remove();
    $('[name=NextPageToken]').remove();
}

/*
    Main get function
*/
function getStoreStock(nextPageToken) {
    const $sizeNotSelected = $('.js-size-not-selected');

    $('.js-location-not-found').hide();
    $('.show-more-btn').hide().addClass('js-hidden-show-more');

    $sizeNotSelected.hide();

    const sizeSelected = $('.flyout-variations li.selectable').length === 0 || $('li.selected .js-swatch-anchor-flyout').length !== 0;
    //if size is not selected, show the error message
    if (!sizeSelected) {
        $('.js-spinner').removeClass('spinner-visible');
        $sizeNotSelected.show();
    } else if (nextPageToken < 25) {
        //maximum of 25 stores
        $.ajax({
            url: Urls.getInStoreAvailability,
            data: {
                productId: getFlyoutProductId(),
                latitude: inStoreData.latitude,
                longitude: inStoreData.longitude,
                nextPageToken: nextPageToken
            }
        }).done(function(response) {
            const responseObj = $(response);
            if (response.length != 0) {
                $('.stores-list-wrapper .error').remove();
                // show list header when there are stores to show in desktop
                $('.js-stores-list-header').addClass('show-header');
            }
            if (nextPageToken == 0) {
                cleanFlyoutStores(); //Clean the flyout
            }
            $('.js-stores-list-wrapper').append(responseObj);
            //More stores button - adds 5 stores to the list to a max of 25 stores
            //When it reached max limit or if the token is null, hide the show more button
            if ($('[name=NextPageToken]').last().val().length > 0 && $('[name=NextPageToken]').last().val() < 25) {
                $('.show-more-btn').show().removeClass('js-hidden-show-more');
            }

            $('.js-spinner').removeClass('spinner-visible');

            if (!isSmallView()){
                $('.js-stores-list-wrapper .js-expand-row-btn').first().find('.store-main-info').click();
            }

            if (nextPageToken > 0) {
                responseObj.find('.js-list-row:first-child').focus();
            }
        });
    }

    $(document).on('keydown', '.wrap-details:last-child .js-list-row:last-child', function(e) {
        if (e.which == 9 && !e.shiftKey) {
            if ($('.show-more-btn').hasClass('js-hidden-show-more')) {
                e.preventDefault();
                $('.js-instore-availability-flyout').find('.js-close-flyout').focus();
            }
        }
    });
}

/**
 * @function
 * @description Initialize JS
 */
module.exports = function() {
    //Initialize Events
    initializeEvents();

    //Initialize Google Place API
    google.places.initStockFlyout(triggerReceiveAddressAutoComplete);
};

module.exports.refreshFlyout = function() {
    //Check if we have some location in memory, If yes, dont get user's address in addressbook
    if (!inStoreData.longitude || !inStoreData.latitude) {
        cleanFlyoutStores();
        //Check if user is loggedin and has valid address. If yes, we search that address in Google API
        const CurrentUserShortAddress = $('[name=CurrentUserShortAddress]')[0].value;
        if (CurrentUserShortAddress !== '') {
            google.places.searchPlace(CurrentUserShortAddress, triggerUserAddressSearched);
        }
    }
};
